import {GetColumnValue} from './getColumnValue';
import {ResultType, ResultTypesEnum, TransformerIdsEnum} from './internal';

export const dataTableType: ResultType = {
  name: ResultTypesEnum.DATA_TABLE,
  properties: {},
  methods: {
    [TransformerIdsEnum.GET_COLUMN_VALUE]: new GetColumnValue(),
  },
};
